module.exports = __webpack_public_path__ + "static/media/news4.4ca1dda8.png";